// src/context/NavigationContext.js
import { createContext, useContext } from 'react';

const NavigationContext = createContext();

export const NavigationProvider = ({ children, navigate }) => {
    return (
        <NavigationContext.Provider value={{ navigate }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = () => useContext(NavigationContext);